import "./portfolio.css";
export function Portfolio() {
  return (
    <div id="portfolio" className=" portfolio">
    <div className="container ">
        <div className="p-3">
            <h1 className="textParams">Портфолио</h1>
        </div>
      <div className="row g-0">
      
        <div className="col-3">
            <img className="img" src={require('./foto/1.jpg')} alt={3}/>
            </div>
        <div className="col-3">
            <img className="img" src={require('./foto/2.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/3.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/4.jpg')} alt={3}/>
        </div>
        
      </div>

      <div className="row g-0">
            
        <div className="col-3">
            <img className="img" src={require('./foto/13.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/6.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/7.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/8.jpg')} alt={3}/>
        </div>
        
      </div>

      <div className="row g-0">
     
        <div className="col-3">
            <img className="img" src={require('./foto/9.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/10.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/11.jpg')} alt={3}/></div>
        <div className="col-3">
            <img className="img" src={require('./foto/12.jpg')} alt={3}/>
        </div>
       
      </div>

       <div className="row g-0">
     
        <div className="col-3">
            <img className="img" src={require('./foto/13.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/14.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/15.jpg')} alt={3}/></div>
        <div className="col-3">
            <img className="img" src={require('./foto/16.jpg')} alt={3}/>
        </div>
       
      </div>

 <div className="row g-0">
     
        <div className="col-3">
            <img className="img" src={require('./foto/17.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/18.jpg')} alt={3}/>
        </div>
        <div className="col-3">
            <img className="img" src={require('./foto/19.jpg')} alt={3}/></div>
        <div className="col-3">
            <img className="img" src={require('./foto/20.jpg')} alt={3}/>
        </div>
       
      </div>
    
     <div className="row g-0">
     
        <div className="col-4">
            <img className="img" src={require('./foto/21.jpg')} alt={3}/>
        </div>
        <div className="col-4">
            <img className="img" src={require('./foto/22.jpg')} alt={3}/>
        </div>
        <div className="col-4">
            <img className="img" src={require('./foto/23.jpg')} alt={3}/></div>
     
       
      </div>
    </div>
    </div>
  );
}
